import React from 'react'
import VoQuizPartsView from '../component/VoQuizPartsView'

const VoQuizParts = ({
  onNumberOfQuestionsSave,
  setNumberOfQuestions,
  numberOfQuestions,
  children,
}) => {
  return (
    <VoQuizPartsView
      setNumberOfQuestions={setNumberOfQuestions}
      numberOfQuestions={numberOfQuestions}
      onNumberOfQuestionsSave={onNumberOfQuestionsSave}
    >
      {children}
    </VoQuizPartsView>
  )
}
export default VoQuizParts
